import React from "react";
import { useDispatch } from "react-redux";
import { addedcart } from "../redux/product/actions";

function Productcart({ item }) {
  const dispatch = useDispatch();
  const { Image, name, Price, Quantity, Category, id, allqty } = item;

  const handelerbutton = () => {
    if (Quantity === 0) {
      alert("product is not available");
    } else {
      dispatch(
        addedcart({
          Image,
          name,
          Price,
          Category,
          id,
          Quantity: 1,
          allqty,
        })
      );
    }
  };
  return (
    <div className="lws-productCard">
      <img className="lws-productImage" src={Image} alt="product" />
      <div className="p-4 space-y-2">
        <h4 className="lws-productName">{name}</h4>
        <p className="lws-productCategory">{Category}</p>
        <div className="flex items-center justify-between pb-2">
          <p className="productPrice">
            BDT <span className="lws-price">{Price}</span>
          </p>
          <p className="productQuantity">
            QTY <span className="lws-quantity">{Quantity}</span>
          </p>
        </div>
        <button className="lws-btnAddToCart" onClick={handelerbutton}>
          Add To Cart
        </button>
      </div>
    </div>
  );
}

export default Productcart;
